/**
 * Píldora de precio con bordes completamente redondeados (rounded-full).
 * Diseño compartido entre BusinessCard, ProductDetailSheet y Food.
 *
 * `price` puede ser número (se formatea con .toFixed(0)) o string ya
 * pre-formateado. Acepta `className` para overrides puntuales.
 */
export default function PricePill({ price, className = '' }) {
  const display = typeof price === 'number' ? price.toFixed(0) : price;
  return (
    <span className={`inline-block bg-product-btn-bg border border-businesscard-price-pill-border text-product-btn-text text-xs font-bold px-1 py-0 rounded-full ${className}`}>
      ${display}
    </span>
  );
}
